module.exports = __webpack_public_path__ + "static/img/report_img_zoblyxgjaqnb.991bc19.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/report_img_zoblyxgjaqnb.png
// module id = SXOS
// module chunks = 21